import React from 'react'
import { useIntl } from 'react-intl'
import classes from './Interpretations.css'
import Interpretation from '../../components/Interpretation'
import {
  getEKGAlgorithmDeterminationDisplayText,
  getEKGInterpretationDisplayTextList,
  getEKGInterpretationSeverityClassName,
  getHighestEKGInterpretationSeverityTypeFromInterpretations,
  getEKGAlgorithmDeterminationClassName,
} from '../../constants/recordingMaps'
import {
  KARDIA_DETERMINATIONS,
} from '../../constants'
import { getPhysicianName } from '../../containers/Utilities'

export const Interpretations = props => {
  const intl = useIntl()
  const {
    fetchingRecording, historyExpanded, interpretationMap, postingForm, recording, me, isServiceProviderEnabled, qtAnalysisData, isQTEnabled,
  } = props

  const {
    algorithmDetermination, recordedAt, memberInterpretations, instantAnalysisNote, algorithmPackage, bpm,
  } = recording

  const hasInterpretations = memberInterpretations && memberInterpretations.length > 0
  let copy
  let highestSeverity

  let createdAt
  let firstName = ''
  let lastName = ''
  let interpretations
  let note
  let id

  if (hasInterpretations) {
    const {
      member: {
        firstName: fn,
        lastName: ln,
      },
      interpretations: ints,
      note: n,
      createdAt: ca,
      id: i,
    } = memberInterpretations[0]
    interpretations = ints
    firstName = fn
    lastName = ln
    note = n
    createdAt = ca
    id = i

    copy = memberInterpretations.slice()
    highestSeverity = getHighestEKGInterpretationSeverityTypeFromInterpretations(interpretations)
  }

  const fetchingIsHappening = fetchingRecording || postingForm

  return (
    <div className={classes.interpretations}>
      {!historyExpanded &&
        hasInterpretations && (
        <Interpretation
          key={id}
          severityClass={getEKGInterpretationSeverityClassName(highestSeverity)}
          reviewer={intl.formatMessage(
            {
              id: 'confirmation.Reviewed_by',
            },
            {
              reviewer: getPhysicianName(firstName, lastName),
            },
          )}
          date={createdAt}
          interpretationTitle={getEKGInterpretationDisplayTextList(interpretationMap, interpretations)}
          note={note}
          me={me}
          qtAnalysisData={qtAnalysisData}
          isServiceProviderEnabled={isServiceProviderEnabled}
          interpretation={memberInterpretations[0]}
          isQTEnabled={isQTEnabled}
        />
      )}
      {!historyExpanded &&
        !hasInterpretations && (
        <Interpretation
          severityClass={getEKGAlgorithmDeterminationClassName(algorithmDetermination, algorithmPackage, bpm)}
          reviewer={KARDIA_DETERMINATIONS[recording.algorithmPackage]}
          date={recordedAt}
          interpretationTitle={getEKGAlgorithmDeterminationDisplayText(algorithmDetermination, algorithmPackage, bpm)}
          note={instantAnalysisNote}
        />
      )}
      {/* <ReactCSSTransitionGroup
        transitionName="interpretationItems"
        transitionEnterTimeout={100}
        transitionLeave={false}
      > */}
      {historyExpanded &&
        hasInterpretations && (
        <Interpretation
          severityClass={getEKGAlgorithmDeterminationClassName(algorithmDetermination, algorithmPackage, bpm)}
          reviewer={KARDIA_DETERMINATIONS[recording.algorithmPackage]}
          date={recordedAt}
          interpretationTitle={getEKGAlgorithmDeterminationDisplayText(algorithmDetermination, algorithmPackage, bpm)}
          note={instantAnalysisNote}
          me={me}
        />
      )}
      {historyExpanded &&
          hasInterpretations &&
          copy.reverse().map((interpretation, i) => {
            const {
              member: {
                firstName: fn,
                lastName: ln,
              },
              interpretations: ints,
              note: n,
              createdAt: ca,
              id: idd,
            } = interpretation
            const highestSeverityCopy = getHighestEKGInterpretationSeverityTypeFromInterpretations(ints)
            return (
              <Interpretation
                key={idd}
                severityClass={getEKGInterpretationSeverityClassName(highestSeverityCopy)}
                reviewer={intl.formatMessage(
                  {
                    id: 'confirmation.Reviewed_by',
                  },
                  {
                    reviewer: getPhysicianName(fn, ln),
                  },
                )}
                date={ca}
                interpretationTitle={getEKGInterpretationDisplayTextList(interpretationMap, ints)}
                note={n}
                me={me}
                isServiceProviderEnabled={isServiceProviderEnabled}
                qtAnalysisData={qtAnalysisData}
                interpretation={interpretation}
                isQTEnabled={isQTEnabled}
              />
            )
          })}
      {/* </ReactCSSTransitionGroup> */}
    </div>
  )
}

export default Interpretations



// WEBPACK FOOTER //
// ./src/legacy/components/Interpretations/Interpretations.jsx